// extracted by mini-css-extract-plugin
export default {"modalOverlay":"mQ-z","modalContent":"nQ-z","header":"oQ-z","close":"pQ-z"};